import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M18.106 2.25a3.645 3.645 0 0 1 0 7.29h-2.144v4.92h2.143a3.645 3.645 0 1 1-3.644 3.645v-2.143H9.539v2.143a3.645 3.645 0 1 1-3.644-3.644H8.13V9.539H5.895a3.645 3.645 0 1 1 3.644-3.644V8.13h4.922V5.895a3.645 3.645 0 0 1 3.644-3.645M5.894 15.96a2.145 2.145 0 1 0 2.144 2.145v-2.144zm10.066 2.145a2.145 2.145 0 1 0 2.144-2.144h-2.144zM9.63 14.462h4.832V9.63H9.63zM5.895 3.75a2.145 2.145 0 0 0 0 4.29h2.144V5.894c0-1.185-.96-2.145-2.144-2.145m12.21 0c-1.184 0-2.144.96-2.144 2.145v2.144h2.144a2.145 2.145 0 0 0 0-4.289",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }